import { Dispatch, SetStateAction } from "react";
import { WorkTitle } from "./workDetailPage/WorkTitle";
import { useTranslation } from "./hooks/useTranslation";
import { useLanguage } from "./contexts/LanguageContext";
import mainImage from './image/works/work16MainImage.webp';
import Navigator from './components/Navigation';
import { MainImage } from "./workDetailPage/WorkMainImage";
import BackButton from "./components/BackButton";
import NextItem from "./components/NextItem";
import thumbnail13 from './image/workThumbnails/thumbnail13.webp';
import { Waiting } from "./components/Waiting";
import { WorkTextSection } from "./workDetailPage/WorkTextSection";
import { WorkImage } from "./workDetailPage/WorkImage";
import overviewImage from './image/works/work16overview.webp';
import overviewImagekor from './image/works/work16overviewkor.webp';
import { WorkFullImage } from "./workDetailPage/WorkFullImage";
import feature1 from './image/works/work16feature1.webp';
import feature1kor from './image/works/work16feature1kor.webp';
import feature2 from './image/works/work16feature2.webp';
import feature3 from './image/works/work16feature3.webp';
import feature3kor from './image/works/work16feature3kor.webp';
import design1 from './image/works/work16design1.webp';
import design2 from './image/works/work16design2.webp';
import design3 from './image/works/work16design3.webp';
import design3kor from './image/works/work16design3kor.webp';
import design4 from './image/works/work16design4.webp';
import design5 from './image/works/work16design5.webp';
import design6 from './image/works/work16design6.webp';
import design7 from './image/works/work16design7.webp';
import design8 from './image/works/work16design8.webp';
import design9 from './image/works/work16design9.webp';
import design10 from './image/works/work16design10.webp';
import design11 from './image/works/work16design11.webp';
import design15 from './image/works/work16design12.webp';
import design13 from './image/works/work16design13.webp';
import design14 from './image/works/work16design14.webp';
import design12 from './image/works/work15next1.webp';
import design12kor from './image/works/work15next1kor.webp';
import design13Video from './image/works/work16vedio.mov';
import { Divider } from "@mui/material";
import WorkImageGroup from "./components/WorkImageGroup";
import { WorkVideo } from "./workDetailPage/WorkVideo";
import { useMetaTags } from './utils/useMetaTags';

function Work16(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
    const { language } = useLanguage();
    
    // 이미지들을 객체로 관리 (kor 버전 포함)
    const images = {
      overviewImage,
      overviewImagekor,
      feature1,
      feature1kor,
      feature2,
      feature3,
      feature3kor,
      design1,
      design2,
      design3,
      design3kor,
      design4,
      design5,
      design6,
      design7,
      design8,
      design9,
      design10,
      design11,
      design12,
      design12kor,
      design13,
      design14,
      design15,
    };
    
    // 언어에 따라 이미지 선택하는 함수
    const getImage = (imageName: string): string => {
      // 한국어일 때 kor 버전 이미지 찾기
      if (language === 'ko') {
        const korImageName = `${imageName}kor`;
        const korImage = images[korImageName as keyof typeof images];
        
        // kor 버전이 있으면 사용, 없으면 원본 사용
        if (korImage) {
          return korImage;
        }
      }
      
      // 영어이거나 kor 버전이 없으면 원본 이미지 사용
      return images[imageName as keyof typeof images] || '';
    };
  
    // WorkTitle 수동 번역(ko) 전달용 텍스트
    const titleKo = 'QR오더의 커버리지 확대';
    const descriptionKo = '다양한 F&B 시장 환경에 맞춰 QR오더의 시장 커버리지 확대';
    const teamKo = '당근';
    const roleKo = '프로덕트 매니징, UXUI 디자인';

    // 영문 기본 텍스트(WorkTitle의 기본값)
    const titleEn = 'Expanding the Coverage of QR Order';
    const descriptionEn = 'Expanding the coverage of QR Order to various F&B market environments.';
    const teamEn = 'Karrot(Daangn)';
    const roleEn = 'Product managing, UXUI Design';

    // 메타태그는 기존처럼 언어에 따라 노출
    const titleText = language === 'ko' ? titleKo : titleEn;
    const descriptionText = language === 'ko' ? descriptionKo : descriptionEn;
    
    useMetaTags({
      title: `${titleText} - Lynkim`,
      description: descriptionText,
      image: '/ogimage.png',
    });
    const teamText = language === 'ko' ? teamKo : teamEn;
    const roleText = language === 'ko' ? roleKo : roleEn;
    
  
  return (
    <>
    <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
          <WorkTitle 
            title={titleEn} 
            description={descriptionEn} 
            team={teamEn} 
            role={roleEn} 
            period={'2025.10. - 2025.12.'}
            titleKo={titleKo}
            descriptionKo={descriptionKo}
            teamKo={teamKo}
            roleKo={roleKo}
          />
        </div>
        <MainImage image={mainImage}/>
        <WorkTextSection 
            title={<div>Overview</div>} 
            description={<div>
                Following the successful launch of the QR Order MVP within just one month in July 2025, I spearheaded its strategic scaling by stabilizing sales and operational pipelines and automating production to accelerate market penetration. I further broadened the product’s reach by architecting a flexible service structure for diverse merchant categories and established a foundational O2O CRM framework through the integration of Karrot Business tools, paving the way for customer engagement.</div>}
            subDescription={<div>
                2025년 7월, 단 1개월 만에 QR오더 MVP를 성공적으로 런칭한 후, 하반기에는 영업 및 운영 파이프라인 안정화와 생산 자동화를 통해 시장 침투를 가속화하며 시장 확장에 초점을 맞췄습니다. 특히 다양한 가맹점 유형을 수용할 수 있도록 제품 커버리지를 넓히고, 당근 비즈니스 도구와 연결하기 위해 당근 로그인을 도입하여, 유저 식별 체계를 구축함으로써 O2O CRM의 기틀을 마련했습니다. </div>}
        />
        <WorkImage image={getImage('overviewImage')} isMaxheight={false} isbottomPadding={true} />
        <Divider/>
        <WorkTextSection 
            title={<div>Expanding Market Coverage</div>} 
            description={<div>
                To achieve successful market penetration, it was critical to identify the characteristics of each commercial district's core customer base and define the essential features accordingly. Through extensive research into varying user experiences by location, we identified three distinct sectors with clearly differentiated customer segments: <b>Business, Academic, and Tourist districts.</b> Based on these insights, we advanced our QR order service to align with the specific behaviors of each district and sequentially expanded key payment methods to meet district-specific requirements, strengthening business competitiveness.
            </div>}
            subDescription={<div>
                성공적인 시장 침투를 위해서는 각 상권별 핵심 고객층의 특성을 파악하고, 그에 따른 필수 기능을 정의하는 것이 무엇보다 중요했습니다. 상권별 사용자 경험의 차이를 면밀히 리서치한 결과, 고객층이 뚜렷하게 구분되는 세 가지 <b>핵심 상권(오피스, 교육, 관광)</b>을 도출했습니다. 우리는 각 상권의 사용자 행태에 최적화된 형태로 QR오더 서비스를 고도화했으며, 상권별 요구에 맞는 주요 결제 수단을 순차적으로 확대하여 비즈니스 경쟁력을 강화했습니다.
            </div>}
        />
        <WorkImage image={getImage('feature1')} isMaxheight={true} isbottomPadding={true} />

        <WorkTextSection
            title={<div>QR Order Models by Merchant Type</div>} 
            description={<div>
                At the MVP stage, we validated core features targeting table-service restaurants. However, we recognized that QR ordering environments vary significantly by industry, each with distinct requirements. To address this diversity, we designed and developed five customized QR order models that reflect diverse market contexts, expanding product coverage.
            </div>}
            subDescription={<div>
                MVP 단계에서는 테이블 서빙 중심의 일반 음식점을 타겟으로 핵심 기능을 검증했습니다. 하지만 실제 QR오더가 도입되는 환경은 업종별로 매우 다양하며, 그에 따른 요구사항 또한 각기 다르다는 점에 주목했습니다. 이를 해결하기 위해 우리는 시장의 다양한 맥락을 반영한 5가지 맞춤형 QR오더 모델을 설계하고 개발하여 제품의 커버리지를 확장했습니다.
                </div>}
        />
        <WorkImage image={getImage('feature2')} isMaxheight={true} isbottomPadding={false} />
        <WorkTextSection
            description={<div>
                <b>(1) Prepaid Store QR Order:</b> QR order for table-service restaurants, primarily used in general restaurants, handling everything from ordering to payment.<br/>
                <b>(2) Postpaid Store QR Order:</b> QR order for table-service restaurants, used in venues with frequent re-orders such as bars, handling only the ordering process.<br/>
                <b>(3) Pickup Store QR Order:</b> QR order for stores where customers collect items directly, used in cafes, takeout spots, and fast-food chains, replacing kiosk functionality.<br/>
                <b>(4) Multi-Store Group Hall QR Order:</b> Group hall QR order that enables placing orders from multiple stores at once, used in highway rest areas and department store food courts.<br/>
                <b>(5) Single-Store Group Hall QR Order:</b> Group hall QR order that restricts ordering to one store at a time, primarily used in corporate campus cafes and campus cafeterias.
            </div>}
            subDescription={<div>
                <b>(1) 선불 매장 QR오더:</b> 테이블에 직접 서빙하는 매장의 QR오더로, 일반 음식점에서 주로 사용되어 주문부터 결제까지 모두 해결하는 QR오더<br/>
                <b>(2) 후불 매장 QR오더:</b> 테이블에 직접 서빙하는 매장의 QR오더로, 추가주문이 많은 주점 등에 사용되어 주문까지만 대체하는 QR오더<br/>
                <b>(3) 픽업 매장 QR오더:</b> 직접 메뉴를 수령해가는 매장 QR오더로,  카페, 테이크아웃, 패스트푸드 등 키오스크 기능을 대체하는 QR오더<br/>
                <b>(4) 일괄주문 그룹관 QR오더:</b> 한 번에 여러 매장에 주문을 할 수 있는 그룹관 QR오더로, 휴게소, 백화점 푸드코트 등에서 사용되는 QR오더<br/>
                <b>(5) 개별주문 그룹관 QR오더:</b> 한번에 하나의 매장에만 주문을 할 수 있는 그룹관 QR오더로, 주로 사내단지 카페, 캠퍼스 학식 등에 사용되는 QR오더
            </div>}
        />
        <WorkTextSection 
            description={<div>
                Essential required features and available service scope varied significantly depending on the merchant type. To manage this complexity, we systematically structured product specifications and feature sets tailored to each environment.
            </div>}
            subDescription={<div>
                매장 타입에 따라 필수 요구 기능과 제공 가능한 서비스 범위가 모두 달랐습니다. 우리는 이러한 복잡성을 해결하기 위해 매장 환경별로 제품 스펙과 기능 구성을 체계적으로 구조화했습니다.
            </div>}
        />
        <WorkImage image={getImage('feature3')} isMaxheight={false} isbottomPadding={true}  />
        
        <WorkTextSection
            title={<div>UX Optimization for Group Hall</div>} 
            description={<div>    
                Expanding beyond the single-store model to pickup and group hall (multi-tenant) environments, I conducted comprehensive UX design considering the operational characteristics of each merchant type. To ensure stable pickup service, I established <b>a single-session entry restriction policy</b> (unlike table-order QR orders) to prevent order confusion, and restructured the information architecture in the cart and order history to facilitate merchant identification in group hall environments. Additionally, for single-store ordering group halls, I designed <b>an automated menu-replacement logic</b> that replaces existing items when adding menus from other stores, optimizing the individual ordering experience per merchant.
                </div>}
            subDescription={<div>
                기존의 단일 매장 모델을 넘어 픽업 및 그룹관(Multi-tenant) 환경으로 서비스를 확장하며, 각 매장 타입의 운영 특성을 고려한 전반적인 UX 설계를 진행했습니다. 특히 픽업 서비스의 안정성을 위해, 테이블 주문 QR오더와 달리, <b>단일 세션 진입 제한 정책</b>을 수립하여 주문 혼선을 방지하고, 그룹관 환경에서 매장 식별이 용이하도록 장바구니와 주문 내역의 정보 구조를 개편했습니다. 또한 개별주문 그룹관에 대해서는, 다른 매장 메뉴 추가 시 <b>기존 항목을 대체하는 로직</b>을 설계하여 매장별 개별 주문 경험을 최적화했습니다.
            </div>}
        />
        <WorkFullImage image={getImage('design1')} isMargin={true} isBottomMargin={false} isRoundedCorner={false} isBackgroundColor={false} />
        <WorkFullImage image={getImage('design2')} isMargin={true} isBottomMargin={true} isRoundedCorner={false} isBackgroundColor={false} />
        <WorkTextSection
            title={<div>Expanded payment infrastructure</div>}
            description={
                <div>
                    We researched payment behavior patterns by commercial district and expanded payment infrastructure to eliminate transaction barriers for diverse user groups, including corporate employees, international tourists, and underage users.
                </div>
            }
            subDescription={<div>
                그리고 상권에 따른 결제 행동 양식을 리서치했고, 그에 따라 직장인, 외국인 관광객, 미성년자 등 다양한 사용자층의 결제 장벽을 제거하기 위해 결제 인프라를 확장했습니다.
            </div>}
        />
        <WorkImage image={getImage('design3')} isMaxheight={false} isbottomPadding={false} />
        <WorkTextSection
            description={<div>
                We strategically prioritized payment method integration based on the characteristics of our key contracted merchants. At the time, responding to business and tourist/commercial districts—including Hyundai Heavy Industries corporate campus cafes, department store food courts, and major tourist-area restaurants—was urgent, so we prioritized these areas. We first integrated <b>mobile payment services (Naver Pay, Kakao Pay, Toss Pay)</b>, which have the highest domestic usage, to ensure usability. Subsequently, reflecting the high proportion of tourists from Japan, China, and English-speaking countries, we sequentially integrated <b>international card payments (VISA, Mastercard, Amex) and international mobile payments (Alipay)</b> to build a global payment infrastructure.
             </div>}
            subDescription={<div>
                우리는 주요 계약 매장들의 특성에 맞추어 결제 수단 도입의 우선순위를 전략적으로 설정했습니다. 당시 현대중공업 사내 단지 카페, 백화점 푸드코트, 주요 관광지 식당 등 오피스와 관광/상업형 상권에 대한 대응이 시급했기 때문에 이를 최우선으로 고려했습니다. 먼저 국내 사용 비중이 가장 높은 <b>간편결제(네이버페이, 카카오페이, 토스페이)</b>를 도입하여 사용성을 확보한 후, 일본·중국 및 영어권 관광객의 비중이 높은 점을 반영하여 <b>해외 카드 결제(VISA, MASTER, Amex)와 해외 간편결제(알리페이)</b>를 순차적으로 연동함으로써 글로벌 결제 인프라를 구축했습니다.
                </div>}
        />
        <WorkFullImage image={getImage('design4')} isMargin={false} isBottomMargin={true} isRoundedCorner={false} isBackgroundColor={true} />
        <WorkTextSection
            title={<div>Sales & Operational Excellence</div>}
            description={<div>
                To efficiently handle the large-scale influx of QR order adoption requests, systematizing and optimizing sales and operational processes was also set as a core task. We focused on three key aspects: <b>(1) building an integrated process</b> spanning from sales to actual store installation and post-management; <b>(2) optimizing the brand experience</b> at the moment merchants receive and first encounter QR order products; and <b>(3) establishing a process</b> to detect service churn signs in advance and respond accordingly, preparing a response process to improve customer retention.
            </div>}
            subDescription={<div>
                앞으로 대규모로 유입되는 QR오더 도입 신청에 효율적으로 대응하기 위해, 영업 및 운영 프로세스를 체계화하고 최적화하는 것 또한 핵심 과제로 설정했습니다. 특히 세 가지 측면에 집중하여 프로젝트를 추진했습니다. (1) 영업부터 실제 매장 설치 및 사후 관리까지 이어지는 전 과정의 통합 프로세스를 구축했으며, (2) 가맹점이 QR오더 제품을 수령하고 처음 접하는 순간의 브랜드 경험을 최적화했습니다. (3)서비스 이탈 징후를 사전에 감지하고 이에 대응하는 프로세스를 마련하여 고객 유지율(Retention)을 높이기 위한 대응 프로세스를 마련했습니다.
                </div>}
        />
        <WorkImage image={getImage('design5')} isMaxheight={false} isbottomPadding={false} />
        <WorkImage image={getImage('design6')} isMaxheight={false} isbottomPadding={false} />
        <WorkImageGroup
            images={[getImage('design7'), getImage('design8'), getImage('design9')]}
        />
        <WorkTextSection
            description={<div>
                Unlike app services, offline-integrated services have the characteristic that merchants can discontinue use by removing devices without formal cancellation procedures, making it difficult to immediately detect service churn. To address this issue, we built a proactive monitoring system that can quickly identify service churn signs or error situations. We compared merchant operating hours data with actual order data and designed the system to automatically send alerts at scheduled times daily to merchants whose stores are operating but have zero weekly orders. This enables continuous monitoring of non-order situations and establishes a foundation for proactive response to potential churn merchants.
            </div>}
            subDescription={<div>
                오프라인 결합 서비스는 앱 서비스와 달리 공식적인 해지 절차 없이도 기기 제거를 통해 이용을 중단할 수 있어, 서비스 이탈을 즉각적으로 감지하기 어렵다는 특성이 있습니다. 이러한 문제를 해결하기 위해 서비스 이탈 징후나 오류 상황을 빠르게 인지할 수 있는 능동적인 모니터링 체계를 구축했습니다. 가맹점의 영업 시간 데이터와 실제 주문 데이터를 대조하여, 매장이 운영 중임에도 주간 주문량이 '0건'인 가맹점을 대상으로 매일 정해진 시간에 자동 얼럿이 발송되도록 설계했습니다. 이를 통해 주문 미발생 상황을 상시 모니터링하고, 잠재적 이탈 가맹점에 선제적으로 대응할 수 있는 기반을 마련했습니다.
            </div>}
        />
        <WorkImageGroup
            images={[getImage('design10'), getImage('design11')]}
        />
        <WorkTextSection
            title={<div>O2O CRM Infrastructure</div>}
            description={<div>
                The final critical priority was establishing a robust infrastructure for an organic, integrated CRM system that bridges online and offline experiences. As a starting point, we <b>introduced Karrot Login</b> to integrate 'Karrot QR Order' with 'Karrot Business' and established a User Identification Framework, laying the foundation for advanced O2O CRM capabilities. This integrated infrastructure connects the entire data journey from online discovery to offline transactions, serving as a powerful foundation for future sophisticated targeted marketing and personalized customer experiences.
            </div>}
            subDescription={<div>
                마지막 핵심 과제는 온라인과 오프라인을 유기적으로 잇는 통합 CRM 시스템의 기반 인프라를 구축하는 것이었습니다. 그 시작으로 <b>당근 로그인을 도입</b>하여 '당근 QR오더'를 '당근 비즈니스'와 통합하여 유저 식별 체계(User Identification Framework)를 확립했으며, 이를 통해 고도화된 O2O CRM 역량을 확보할 수 있는 기틀을 마련했습니다. 이러한 통합 인프라는 온라인에서의 탐색이 오프라인에서의 실제 결제로 이어지는 전 과정을 데이터로 연결하여, 향후 정교한 타겟 마케팅과 개인화된 고객 경험을 제공할 수 있는 강력한 토대가 되었습니다.
            </div>}
        />
        
        <WorkImage image={getImage('design12')} isMaxheight={false} isbottomPadding={false} />

        <WorkTextSection
            title={<div>Karrot Login UX design</div>}
        />
        <WorkVideo video={design13Video} />

        <WorkTextSection
            title={<div>Results</div>}
            description={<div>
                Since its official launch in July 2025, QR Order has maintained growth momentum based on stabilized sales and operational processes, enhanced brand experiences, and strategic expansion of payment infrastructure. As a result, as of December, we achieved <b>monthly Gross Merchandise Volume (GMV) of approximately 300 million KRW</b>, with <b>17,000 monthly active users</b> and <b>40 contracted merchants</b>, expanding market share.
            </div>}
            subDescription={<div>
                2025년 7월 정식 출시 이후, QR오더는 영업 및 운영 프로세스의 안정화, 브랜드 경험 고도화, 그리고 결제 인프라의 전략적 확장을 기반으로 성장세를 이어가고 있습니다. 그 결과 12월 기준 <b>월간 결제액(GMV) 약 3억 원</b>을 달성했으며, <b>월간 이용자 수 1.7만 명</b>, <b>도입 가맹점 수 40개</b>를 기록하는 등 시장 내 점유율을 확대해 나가고 있습니다.
            </div>}
        />
        <WorkImage image={getImage('design15')} isMaxheight={false} isbottomPadding={false} 
        description="Contracted Merchants" />
        
        <WorkImageGroup
            images={[getImage('design13'), getImage('design14')]}
            description="Monthly Active Users & Monthly Gross Merchandise Volume (GMV)"
        />
        <NextItem to='/Work13' thumbnail={thumbnail13} nextProjectTitle='Personalized Ads Consent'/>
        <BackButton/>
        <div style={{ height: "400px" }} />
        

        </>
    )
}

export default Work16;